import { http } from '../helpers/axiosHelper';
export default class ReferralTypeService {
   async get() {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/referral-type').then((response) => {
         return response.data;
      });
   }
}
